
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Row, Col, Card, Alert } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

function Profile() {
    const navigate = useNavigate();
    const [userInfo, setUserInfo] = useState({
        name: '',
        email: '',
        password: '', 
    });
    const [alert, setAlert] = useState(null); 
    const [errors, setErrors] = useState({}); 

    useEffect(() => {
        const userInfoFromStorage = localStorage.getItem('user-info');
        if (userInfoFromStorage) {
            setUserInfo(JSON.parse(userInfoFromStorage).user);
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserInfo({ ...userInfo, [name]: value });
        setErrors({ ...errors, [name]: null }); 
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { password, ...updateInfo } = userInfo;
    
        if (!password) {
            delete updateInfo.password;
        }
    
        const userInfoFromStorage = localStorage.getItem('user-info');
        const token = JSON.parse(userInfoFromStorage)?.token;
        const backendUrl = process.env.REACT_APP_BACKEND_URL;
        const origin = localStorage.getItem('user-origin');

        try {
            const response = await fetch(`${backendUrl}/api/user/update`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                body: JSON.stringify(updateInfo),
            });
    
            if (response.ok) {
                const updatedUser = await response.json();
                const currentData = JSON.parse(localStorage.getItem('user-info'));

                currentData.user = updatedUser.user; 
                localStorage.setItem('user-info', JSON.stringify(currentData));
                setAlert({ type: 'success', message: 'Profile updated successfully!' });
    
                // Remove the navigation line, only set an alert on success
                setTimeout(() => {
                    setAlert(null);
                }, 3000);
            } else if (response.status === 422) {
                const errorData = await response.json();
                setErrors(errorData.errors);
                setAlert({ type: 'danger', message: 'Validation errors occurred.' });
            } else {
                throw new Error('Failed to update profile');
            }
        } catch (error) {
            setAlert({ type: 'danger', message: 'Failed to update profile. Please try again later.' });
            console.error(error);
        }
    };
    

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <h4 className="mb-0 font-size-18">Profile</h4>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="#">Profile</a></li>
                                    {/* <li className="breadcrumb-item active">Form Elements</li> */}
                                </ol>
                            </div>
                        </div>
                    </div>

                    <Row>
                        <Col xs={12}>
                            <Card className="mt-4">
                                <Card.Body>
                                    <h4 className="card-title">Profile Details</h4>
                                    {/* <p className="card-title-desc">Examples of <code>.form-control</code> applied to each textual input type.</p> */}

                                    {alert && <Alert variant={alert.type}>{alert.message}</Alert>}

                                    <Form onSubmit={handleSubmit}>
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label column md={2}>Username</Form.Label>
                                            <Col md={10}>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter your name"
                                                    name="name"
                                                    value={userInfo.name}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.name}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.name}
                                                </Form.Control.Feedback>
                                            </Col>
                                        </Form.Group>

                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label column md={2}>Email</Form.Label>
                                            <Col md={10}>
                                                <Form.Control
                                                    type="email"
                                                    placeholder="Enter your email"
                                                    name="email"
                                                    value={userInfo.email}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.email}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.email}
                                                </Form.Control.Feedback>
                                            </Col>
                                        </Form.Group>

                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label column md={2}>Password</Form.Label>
                                            <Col md={10}>
                                                <Form.Control
                                                    type="password"
                                                    placeholder="Enter new password"
                                                    name="password"
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.password}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.password}
                                                </Form.Control.Feedback>
                                            </Col>
                                        </Form.Group>

                                        <Button variant="primary" type="submit" className="float-end">
                                            Update Profile
                                        </Button>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
}

export default Profile;


